export const getArticle = (noun: string): string => {
  const vowels = 'aeiou'

  if (!noun) {
    return ''
  }

  if (vowels.includes(noun[0])) {
    if (noun[0].toLowerCase() === 'u' && noun.length > 1 && !vowels.includes(noun[1])) {
      return 'a'
    }
    if (noun.toLowerCase().startsWith('eu') && noun.length > 2 && !vowels.includes(noun[2])) {
      return 'a'
    }
    return 'an'
  }
  if (/^(hour|honest|honour|heir|x-ray)/i.test(noun)) {
    return 'an'
  }
  return 'a'
}

export const capitalize = (word: string): string => {
  if (!word) return ''
  return word.charAt(0).toUpperCase() + word.slice(1)
}
